import cn from "classnames";

import { Text } from "shared/components/Text";

import css from "./styles.module.scss";

export const PhotosSlider = ({
	slidingEntries,
	slideDirection,
	setSlideDirection,
	onAnimationEnd,
	swipeLeft,
	swipeRight,
	offset,
	className,
}) => {
	const isMobile = window.matchMedia("(max-width: 820px)").matches;

	return (
		<div
			className={cn(
				css.PhotosSlider,
				{
					[css.moveRight]: slideDirection === "right",
					[css.moveLeft]: slideDirection === "left",
				},
				className
			)}
			onAnimationEnd={onAnimationEnd}
		>
			{slidingEntries.map((el, i) => (
				<button
					onClick={() =>
						i === offset - 1
							? swipeLeft()
							: i === offset + 1
							? swipeRight()
							: null
					}
					className={cn(css.photoContainer, {
						[css.currentPhoto]: i === offset,
						[css.pointerButton]: i === offset - 1 || i === offset + 1,
					})}
					key={el.name}
				>
					<img
						src={isMobile ? el.mobilePhoto : el.photo}
						alt=""
						className={css.photo}
					/>
					<Text type="white" className={css.photoCaption} bold secondaryFamily>
						{el.name}
					</Text>
				</button>
			))}
		</div>
	);
};
